import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=1de89a8c&scoped=true"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"
import style0 from "./dashboard.vue?vue&type=style&index=0&id=1de89a8c&prod&lang=css"
import style1 from "./dashboard.vue?vue&type=style&index=1&id=1de89a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de89a8c",
  null
  
)

export default component.exports